// the find controller reads the page text with the same params, and the match
// offsets only line up with text read exactly like that
export const PDF_VIEWER_SEARCH_TEXT_CONTENT_PARAMS = {
  disableNormalization: true,
}

export const PDF_VIEWER_SEARCH_SNIPPET_LENGTH = 80

export const PDF_VIEWER_SEARCH_RESULTS_LIMIT = 200
